import { axiosInstance } from '../instance';

const MachineList = () => {
    return axiosInstance
        .get('/api/machine');
}

const Machine = (id) => {
    return axiosInstance
        .get('/api/machine/' + id)
}

const MachineListUpdate = (machine) => {
    return axiosInstance
        .post('/api/machine', machine);
}

const MachineListDelete = (id) => {
    return axiosInstance
        .delete('/api/machine/' + id);
}

const ActiveMachinesList = () => {
    return axiosInstance
        .get('/api/machine/active');
}

export { MachineList, Machine, MachineListUpdate, MachineListDelete, ActiveMachinesList };
